import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'

const responseParser = (response: any) => {
  return response
}

const removeUnwantedFields = (reqValues: any[]) => {
  const filteredValues = []
  for (let i = 0; i < reqValues.length; i++) {
    filteredValues.push({
      key: reqValues[i].key,
      status: reqValues[i].status,
      value: reqValues[i].value,
      configValuesReferenceId: reqValues[i].configValuesReferenceId,
    })
  }
  return filteredValues
}

const removeConfigRequest = (entityId: string, configValues: any[], configurations?: any[]) => {
  return {
    entityId: entityId,
    configValues: removeUnwantedFields(configValues),
    ...(configurations && { configurations: configurations }),
  }
}

const removeConfigOfEntityApi = (entityId: string, configValues: any[], configurations: any[], tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.removeConfig,
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: removeConfigRequest(entityId, configValues, configurations),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { removeConfigOfEntityApi }
